import { Factory } from './factory';
import { Book } from '../book';
import { Image } from '../image';

export class BookFactory implements Factory<Book> {

    buildFromFactory(): Book {
        return undefined;
    }

    buildFromObject(jsonObject: any): Book {
        const book = new Book();
        book.id = +jsonObject.id;
        book.name = jsonObject.name;
        book.link = jsonObject.link;
        book.thumbnailCover = new Image();
        book.thumbnailCover.url = jsonObject.coverThumbnailImage.url;
        book.thumbnailCover.width = +jsonObject.coverThumbnailImage.width;
        book.thumbnailCover.height = +jsonObject.coverThumbnailImage.height;

        return book;
    }
}
